module.exports = __webpack_public_path__ + "static/media/sanbao.ffb24f7b.jpg";